module.exports = __webpack_public_path__ + "img/vegetable-asparagus-190x100.13ba7fcc.jpg";